{
  "truck": { "name": "Camión", "capacity": 10, "speed": 30, "handlingSeconds": 3 }
}
